/** Which controls to show: phones and tablets get touch controls and hints, computers get keyboard and mouse.
 * Decided by the primary input, not the screen size: a touch laptop with a mouse is 'desktop', an iPad is 'touch'. */
export type DeviceKind = 'touch' | 'desktop';

export function detectDevice(): DeviceKind {
  if (typeof window === 'undefined' || typeof matchMedia !== 'function') return 'desktop';
  const coarse = matchMedia('(pointer: coarse)').matches;
  const noHover = matchMedia('(hover: none)').matches;
  // iPadOS reports a desktop user agent, but a coarse primary pointer and touch points.
  return coarse || (noHover && navigator.maxTouchPoints > 0) ? 'touch' : 'desktop';
}
